import store from "@/store";

export default [
    {
        path: '/',
        component: () => import('../components/layouts/layout-default'),
        children: [
            {
                path: '/',
                component: () => import('../components/context'),
                children: [
                    {
                        path: '/',
                        name: 'home',
                        component: () => import('../components/context/context-start'),
                        props: true,
                        meta: {
                            actions: [
                                {action: "task/one"},
                            ],
                            isTaskFullscreen: true,
                            /*actions: [
                                {action: "user/tasks", subscribe: ["user"]},
                            ],*/
                            title: () => "1Task",//store.state.page.task.TITLE
                        },
                    },
                    {
                        path: '/x/:contextId',
                        name: 'context',
                        component: () => import('../components/context/context-content'),
                        props: true,
                        meta: {
                            actions: [
                                // TODO THIS IS UNSECURE TO SUBSCRIBE WITHOUT CHECKING VALID ACCESS !!!!!!!!!!
                                {
                                    action: "context/item",
                                    subscribe: ["context"],
                                    isContext: true,
                                    withErrorHandler: true,
                                    // ?tag=<id> в URL -> tagId в запросе (быстрый тег группы)
                                    queryMap: {tag: "tagId"},
                                },
                            ],
                            title: () => store.state.page.context.TITLE
                        },
                        /*children: [
                            {
                                name: 'context-done',
                                path: '/x/:contextId/done',
                                component: () => import('../components/context/context-content-task'),
                                props: true,
                                meta: {
                                    actions: [
                                        // TODO THIS IS UNSECURE TO SUBSCRIBE WITHOUT CHECKING VALID ACCESS !!!!!!!!!!
                                        {action: "context/item", subscribe: ["context"], isContext: true},
                                    ],
                                    title: () => "Все сделано!"
                                }
                            },
                            {
                                name: 'context-task',
                                path: '/x/:contextId/:taskId',
                                component: () => import('../components/context/context-content-task'),
                                props: true,
                                meta: {
                                    actions: [
                                        // TODO THIS IS UNSECURE TO SUBSCRIBE WITHOUT CHECKING VALID ACCESS !!!!!!!!!!
                                        {action: "context/item", subscribe: ["context"], isContext: true, withErrorHandler: true},
                                        {action: "task/item", subscribe: ["task"], withAnon: true},
                                    ],
                                    title: () => store.state.page.task.TITLE
                                }
                            },
                        ]*/
                    },
                    {
                        // цепочка контекстов для панельного режима: /c/<id1>.<id2>.<id3>
                        path: '/c/:contextIdChain',
                        name: 'context-chain',
                        component: () => import('../components/context/context-content'),
                        props: true,
                        meta: {
                            actions: [
                                {
                                    action: "context/chain",
                                    isContext: true,
                                    withErrorHandler: true,
                                },
                            ],
                            title: () => store.state.page.contexts?.[store.state.page.contexts.length - 1]?.item?.name
                        },
                    },
                    {
                        path: '/x/:contextId/:taskId/:contentId?',
                        name: 'context-task',
                        components: {
                            default: () => import('../components/context/context-content'),
                            task: () => import('../components/task/task-panel'),
                        },
                        props: {default: true},
                        meta: {
                            actions: [
                                // TODO THIS IS UNSECURE TO SUBSCRIBE WITHOUT CHECKING VALID ACCESS !!!!!!!!!!
                                {
                                    action: "context/item",
                                    subscribe: ["context"],
                                    isContext: true,
                                    withErrorHandler: true,
                                },
                                {
                                    action: "task/item",
                                    subscribe: ["task"],
                                    isTask: true,
                                    withAnon: true
                                },
                            ],
                            title: () => store.state.page.task.TITLE
                        }
                    },
                ]
            },
            /*{
                name: '1task-start',
                path: '/1',
                component: () => import('../components/context/context-content-task'),
                props: true,
                meta: {
                    actions: [
                        {action: "task/one"},
                    ],
                    isTaskFullscreen: true,
                    title: () => store.state.page.task.TITLE
                }
            },*/
            /*{
                name: '1task-done',
                path: '/1/done',
                component: () => import('../components/context/context-content-done'),
                //props: true,
                meta: {
                    /!*actions: [
                        {action: "user/tasks", subscribe: ["user"]},
                    ],*!/
                    //isTaskFullscreen: false,
                    title: () => "Все сделано!"
                }
            },*/
            /*{
                name: '1task',
                path: '/1/:taskId/:contentId?',
                component: () => import('../components/context'),
                props: true,
                meta: {
                    actions: [
                        {action: "task/item", apiless: true},
                    ],
                    isTaskFullscreen: true,
                    title: () => store.state.page.task.TITLE
                }
            },*/
            {
                path: '/1',
                component: () => import('../components/context'),
                children: [
                    {
                        name: '1task-start',
                        path: '/1',
                        components: {
                            default: () => import('../components/context/context-content'),
                            task: () => import('../components/task/task-panel'),
                        },
                        props: {default: true},
                        meta: {
                            actions: [
                                {action: "task/one"},
                            ],
                            isTaskFullscreen: true,
                            title: () => store.state.page.task.TITLE
                        }
                    },
                    {
                        name: '1task-done',
                        path: '/1/done',
                        component: () => import('../components/context/context-content-done'),
                        //props: true,
                        meta: {
                            /*actions: [
                                {action: "user/tasks", subscribe: ["user"]},
                            ],*/
                            //isTaskFullscreen: false,
                            title: () => "Все сделано!"
                        }
                    },
                    {
                        name: '1task',
                        path: '/1/:taskId/:contentId?',
                        components: {
                            default: () => import('../components/context/context-content'),
                            task: () => import('../components/task/task-panel'),
                        },
                        props: {default: true},
                        meta: {
                            actions: [
                                {action: "task/item", apiless: true},
                            ],
                            isTaskFullscreen: true,
                            title: () => store.state.page.task.TITLE
                        }
                    },
                ]
            },
            {
                path: '/t',
                component: () => import('../components/context'),
                children: [
                    {
                        name: 'task',
                        path: '/t/:taskId/:contentId?',
                        components: {
                            default: () => import('../components/context/context-content'),
                            task: () => import('../components/task/task-panel'),
                        },
                        props: {default: true},
                        meta: {
                            actions: [
                                {action: "task/item", withAnon: true,},
                            ],
                            isTaskFullscreen: true,
                            title: () => store.state.page.task.TITLE
                        }
                    },
                ]
            },
            {
                path: '/new',
                name: 'new',
                component: () => import('../components/context'),
                props: true,
                meta: {
                    actions: [
                        {action: "task/create"},
                    ],
                    isTaskFullscreen: true,
                    title: () => "Новая задача"
                }
            },
        ]
    },

    {
        path: '/_/auth',
        //name: 'auth',
        component: () => import('../components/auth'),
        meta: {
            skipSession: true,
        },
        children: [
            {
                name: 'auth',
                path: '/_/auth',
                component: () => import('../components/auth/auth-start'),
                props: true,
                meta: {
                    skipSession: true,
                }
            },
            {
                name: 'auth-success',
                path: '/_/auth/success',
                component: () => import('../components/auth/auth-success'),
                props: true,
                meta: {
                    skipSession: true,
                }
            },
            {
                name: 'auth-with-yandex',
                path: '/_/auth/yandex',
                component: () => import('../components/auth/auth-yandex'),
                props: true,
                meta: {
                    skipSession: true,
                }
            },
            {
                name: 'auth-invite',
                path: '/_/invite/:invitationId',
                component: () => import('../components/auth/auth-invite'),
                props: true,
                meta: {
                    skipSession: true,
                }
            },
            {
                name: 'auth-with-email-link',
                path: '/_/auth/email-link/:token',
                component: () => import('../components/auth/auth-email-link'),
                props: true,
                meta: {
                    skipSession: true,
                }
            },
        ]
    },
    /*{
        path: '/_/auth/:authIM/:authToken',
        name: 'authWithEmail',
        component: () => import('../components/auth'),
        props: true,
        meta: {
            skipSession: true,
        }
    },*/
    {
        path: '/_/auth-as',
        name: 'auth-as',
        component: () => import('../components/auth-as'),
        meta: {
            skipSession: true,
        }
    },
    /*{
        path: '/_/auth-tg',
        name: 'auth-tg',
        component: () => import('../components/auth-tg'),
        meta: {
            skipSession: true,
        }
    },*/
    {
        path: '/_/logout',
        name: 'logout',
        component: () => import('../components/logout'),
        meta: {
            skipSession: true,
        }
    },
    {
        path: '/error/404',
        name: 'error404',
        component: () => import('../components/exception'),
        meta: {code: '404'}
    },
    {
        path: '*',
        name: 'error-unknown',
        component: () => import('../components/exception'),
        props: true,
    },
];
